import { FunctionComponent } from "react";

import { MessageType } from "../../interfaces";
import "./MessageBar.scss";

interface Props {
  text: string;
  type: MessageType;
  className?: string;
  isSnackbar?: boolean;
  Action?: FunctionComponent;
  Animation?: FunctionComponent;
}

export const MessageBar = ({
  text,
  type,
  className,
  isSnackbar,
  Action,
  Animation,
}: Props) => {
  return (
    <div
      className={`message-bar ${type ? `message-bar-${type}` : "info"} ${
        isSnackbar ? "message-bar--is-snackbar" : ""
      }`}
    >
      <p className={`message-bar__message`}>{text}</p>
      {Animation && <Animation />}
      {Action && (
        <div className={`message-bar__action ${className ? className : ""}`}>
          <Action />
        </div>
      )}
    </div>
  );
};
